import {
  Signup,
  SignIn,
  Authorization,
  Forgetpassword,
  Logout,
  Verify_acoount_otp,
  Verify_signin_otp,
  Subusersignuop,
  Getsubsuser,
  ResendOTP,
} from "./login"
import { GetProductPlans } from "./landingpage";

export const actions = {
  Signup,
  SignIn,
  ResendOTP,
  Verify_acoount_otp,
  Verify_signin_otp,
  Subusersignuop,
  Getsubsuser, 
  Authorization,
  Forgetpassword,
  Logout,
  GetProductPlans,
}
